import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';
import 'photoswipe/style.css';
import 'photoswipe-dynamic-caption-plugin/photoswipe-dynamic-caption-plugin.css';

const lightbox = new PhotoSwipeLightbox({
  gallery: '#gallery',
  children: 'a',
  padding: {top: 20, bottom: 20, left: 20, right: 20},
  
  imageClickAction: 'next',
  tapAction: 'next',
  pswpModule: () => import('photoswipe')
});

const captionPlugin = new PhotoSwipeDynamicCaption(lightbox, {
  type: 'below',
});
lightbox.init();
